import Mixin from "../../mixin.js";
import Label from "./Label.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";

var iconic = IconicJS();

const template = `
    <transition name="slide-fade"" mode="out-in" @enter="enter()" appear>

        <div v-show="fs.display(input)"  :id="iuid" :class="computedClasses" aria-label="Summary card containing information about previously entered data." >
            <div class="grid">
                <div v-for="(item, index) in input.excerpt" :class="'twin-button-excerpt s12 ' + item.class" :ref="'excerpt_container_'+input.uid+'_'+index" :id="'excerpt_container_'+input.uid+'_'+index">
                    <span :id="'excerpt_item_'+input.uid+'_field_'+index" :ref="'excerpt_item_'+input.uid+'_field_'+index" class="card-section-title">{{computeExcerptTitle(item)}}</span><br>
                    <span :id="'excerpt_item_'+input.uid+'_value_'+index" :ref="'excerpt_item_'+input.uid+'_value_'+index" class="card-section-value">{{item.value}}</span>
                </div>

            </div>

            <div v-if="showActions" class="grid actions-container">
                <div v-for="action in input.actions" class="s6 m6" >
                    <a v-if="showDelete(action)"
                        :disabled="input.loading"
                        :id="action.id"
                        style="text-transform: uppercase;"
                        @click.prevent="setLoading(input, $event), exec($event, input)"
                        @keydown.space.prevent="emulateClick(input, $event)"
                        @keydown.enter.prevent="emulateClick(input, $event)"
                        :class="actionClass(action.id)"
                        :data-uid="input.uid+'_'+action.id"
                        tabindex='0' 
                        role="button"
                        :aria-label="actionAriaLabel(action, input.excerpt)"
                    >
                        <img  :alt="action.value" class="iconic iconic-sm icon" :src="actionIcon(action)">
                        {{action.value}}
                    </a>
                </div>
            </div>

            <div v-if="input.action_btn_type == 'regular'" class="grid">
                <input
                    :id="input.id+'-id'"
                    :name="input.element_name"
                    type="hidden"
                    :required="input.validation.required"
                    :value="input.value"
                    v-bind="validationRules"
                    :data-uid="input.uid"
                />
            </div>

            <div v-if="input.action_btn_type == 'radio' && !matched" class="grid">
                <div class="s6 clm keep-remove-container" v-for="(item, index) in items"  :id="item.value.toLowerCase()+ '-container'">
                    <input type="radio"
                        :uid="input.uid+ '_option_' + index"
                        :id="input.id + '_option_' + index"
                        :required="input.validation.required"
                        :name="input.element_name"
                        :checked="setChecked(item)"
                        @change="exec($event, input)"
                        :value="item.value"
                        :disabled="setDisabled(item.disabled)"
                        v-bind="validationRules"
                        :data-uid="input.uid"
                    />
                    <qt-label :iuid="iuid" :format="'custom'" :img="fs.icon(item)" :item='item' :item_index='index'></qt-label>
                </div>
            </div>
            <span v-if="matched" class="text-center matched-text" > MATCHED TO YOU </span>
            <div class="error-here"></div>
        </div>
        
    </transition>
`;

export default {
    name: 'b-twin-button-card',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label
    },
    watch: {
        /* John M: deprecated?
        'this.input.excerpt': {
            deep: true,
            handler: function (newVal, oldVal) {
                console.log('excerpt changed');
                this.input.excerpt.length >= 1 ? this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'loading', val: false }): this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'loading', val: true });
            }
        } */
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'vehicles'
        ]),
        showActions: function () {
            if (this.input.action_btn_type == 'regular' && !this.input.loading) {
                return true
            }
        },

        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.actions };
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        isFirstDriver: function () {
            return this.input.uid == 'in_driver_1';
        },
        matched: function () {
            let isMatch = false;
            const uid = 'in_driver_prefill_match';
            const elems = this.funnel.elements;
            if (!Utils.isEmpty(elems[uid]))
                isMatch = elems[uid].value == this.input.uid;
            return isMatch;
        },
        computedClasses: function () {
            var classes = ["card s12 clm twin-button-card"]

            if (this.matched) {
                classes.push("matched")
            } if (this.input.loading) {
                classes.push("loading-button disabled")
            }
            return classes
        },

    },
    update: function () {
        iconic.inject('.icon, .iconic')
    },
    mounted: function () {
        //John M: setting loading status on 'mounted' is not desirable for incomplete cards when you hit the back button.
        // loading is now being set before save for the page in context.
        /* let loading = false;
        if (this.input.excerpt.length > 0) {
            for (const indx in this.input.excerpt) {
                if (this.input.excerpt[indx].value == '') {
                    loading = true;
                    break;
                }
            }
        }
        this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'loading', val: loading }); */
    },
    methods: {
        computeExcerptTitle: function (item) {
            return !Utils.isEmpty(item.label) ? item.label : item.field;
        },
        actionAriaLabel: function(action, excerpt){
            console.log(action.value, excerpt[0].value);
            return action.value +' '+excerpt[0].value;
        },
        emulateClick: function(input, e){
            console.log(e.target.dataset.uid);
            var element = document.querySelector("[data-uid='"+e.target.dataset.uid+"']")
            element.click();
        },
        showDelete: function (action) {
            if (action.id != "edit" && this.isFirstDriver) {
                return false
            } else {
                return true
            }
        },
        actionClass: function (action_id) {
            var action_class = [action_id]

            if (this.input.loading) {
                action_class.push('disabled')
            }
            return action_class
        },
        setLoading: function (input, e) {
            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: input.uid, key: 'loading', val: true });
        },
        enter: function () {
            this.$nextTick(function () {
                iconic.inject('.icon, .iconic')
            })
        },
        setChecked(action) {
            return this.input.value.indexOf(action.value) > -1;
        },
        actionIcon: function (action) {
            if (action.value.toLowerCase() === "delete") {
                return "/static/images/iconic/trash.svg"
            }
            if (action.value.toLowerCase() === "keep") {
                return "/static/images/iconic/plus-thin.svg"
            }
            if (action.value.toLowerCase() === "edit") {
                return "/static/images/iconic/pencil.svg"
            }

        }
    }
};